import React, {Component, h, Fragment} from "preact";
import {useState} from "preact/hooks";
import "./textArea.scss";

type props = {
    placeholder?: string,
    maxlength?: number,
    minlength?: number,
    title?: string,
    height?: string,
    subtitle?: string,
    error?: string,
    maxText?: number,
    onChange?: any,
    input?: any,
    meta?: any,
    valueInput?:any,
    fnToShow?: any
}

export function TextArea({placeholder, maxlength, minlength, title, subtitle, height = '300px', error, onChange, valueInput, ...props} :props) {
    const [text, setText] = useState(valueInput ? valueInput : '')

    const handleChangeText = (value: string) => {
        setText(value)
        onChange(value)
    }

    return <div>
            <label className='form-control-label'>{title}</label>
            <textarea
                value={text}
                placeholder={placeholder}
                maxLength={maxlength}
                minLength={minlength}
                className={`form-control text-area-input ${error && ' text-area-input__error-input'}`}
                style={{height: height}}
                onChange={(e: any) => handleChangeText(e.target.value)}
                {...props}
            />
            {
                subtitle
                ?   <Fragment>
                        <div className='text-area-input__error-text font-16'>
                            <span>{error}</span>
                        </div>
                        <div className='text-area-input__subtitle d-flex flex-space-between font-color-879CA1 font-14 '>
                            <span>{subtitle}</span>
                            {maxlength && <span>{text.length} / {maxlength} caracteres</span>}
                        </div>
                    </Fragment>
                :   <Fragment>
                        <div className='text-area-input__subtitle d-flex flex-space-between '>
                            <span className='font-16 font-color-red'>{error}</span>
                            {maxlength && <span className='font-color-879CA1 font-14'>{text.length} / {maxlength} caracteres</span>}
                        </div>
                    </Fragment>
            }

    </div>
};


export function TextAreaFinalForm ({placeholder, maxlength, minlength, title, subtitle, height, error, onChange, input, meta, valueInput, fnToShow,  ...props} :props) {
    return <TextArea
        title={title}
        subtitle={subtitle}
        error={fnToShow(meta) && meta.error}
        maxlength={maxlength}
        height={height}
        valueInput={valueInput}
        onChange={input.onChange}
    />
}